import { faTimes } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styled from 'styled-components/macro';
import { WxButton, WxLabel } from '../..';
import useAttributes from '../../../hooks/api/queries/useAttributes';
import { useFiltersContext } from '../../../hooks/context/useFiltersContext';
import { __ } from '../../../i18n/l10n';
import { breakpoint } from '../../../styles/constants';
import getPageOffset from '../../../utils/getPageOffset';
import { DesktopFilters } from './DesktopFilters';
import { MobileFiltersAccordion } from './MobileFiltersAccordion';

interface Props {
  setOpen: (state: boolean) => void;
  categoryId: number;
}

export const FiltersMenu = ({ setOpen, categoryId }: Props) => {
  const { saveFilters, discardFilters, subCatList } = useFiltersContext();
  const { data } = useAttributes({ categoryId, subCatList });
  var element = document.getElementById('root');
  const offset = getPageOffset(element);
  let topOffset = window.scrollY > offset ? window.scrollY - offset : 0;

  if (!data) return null;

  return (
    <DivFullScreen topPos={topOffset}>
      <Header>
        <Row>
          <WxLabel label={__('Filters')} active black />
          <BackIcon
            icon={faTimes}
            onClick={() => {
              discardFilters();
              setOpen(false);
            }}
          />
        </Row>
      </Header>
      <MobileFiltersAccordion attrKeys={data} categoryId={categoryId} />
      <DesktopFilters attrKeys={data} categoryId={categoryId} />
      <WxButton
        label={__('View results')}
        onClick={() => {
          saveFilters();
          setOpen(false);
        }}
        type={'classic'}
      />
    </DivFullScreen>
  );
};

const DivFullScreen = styled.div<{ topPos: number }>`
  box-shadow: 0 0 0 100vmax ${({ theme }) => theme.colors.white};
  clip-path: inset(0 -100vmax);
  background-color: ${({ theme }) => theme.colors.white};
  height: 100vh;

  width: 100%;

  position: fixed;
  top: ${({ topPos }) => (topPos ? `${topPos}px` : 0)};
  left: 0;
  z-index: 2;
  display: flex;
  flex-direction: column;
  padding-bottom: 1.25rem;

  @media (min-width: ${breakpoint}) {
    position: absolute;
    padding-bottom: 9rem;
  }

  > :last-child {
    margin-left: auto;
    margin-top: auto;
    margin-bottom: 1.25rem;

    @media (min-width: ${breakpoint}) {
      margin-top: 8rem;
      margin-bottom: 0;
    }
  }
`;

const Header = styled.header`
  padding-block: 1.25rem;
`;

export const BackIcon = styled(FontAwesomeIcon)`
  font-weight: 900;
  font-size: 0.875rem;
  position: absolute;
  right: 0;
  cursor: pointer;
`;

const Row = styled.div`
  display: flex;
  justify-content: center;

  @media (min-width: ${breakpoint}) {
    justify-content: flex-start;
  }
`;

export const LiValue = styled.li<{ selected: boolean }>`
  width: 28px;
  height: 28px;
  border: 1px solid ${({ theme }) => theme.colors.black};
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${({ theme, selected }) =>
    selected ? theme.colors.black : theme.colors.white};

  p {
    color: ${({ theme, selected }) =>
      selected ? theme.colors.white : theme.colors.black};
  }
`;
